import { FaSpinner } from "react-icons/fa6"

export default function Loading() {
  return (
    <FaSpinner className="mx-auto animate-spin text-slate-400 mb-5" size={40} />
  )
}
